var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[(this.$tenant.slug === 'brokerwise-pro')?_c('app-brokerwise-pro'):(this.$tenant.slug === 'ie-brokerwise-pro')?_c('app-ie-brokerwise-pro'):(this.$tenant.slug === 'ni-brokerwise-pro')?_c('app-ni-brokerwise-pro'):(this.$tenant.slug === 'pp-brokerwise-pro')?_c('app-pp-brokerwise-pro'):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }